import type { TaskBase } from "../base/TaskBase"
import type { TaskName } from "../TaskName"

export type TaskZipOptions = {
  readonly enum: TaskName.TASK_ZIP
} & TaskBase
